import type { Environment } from 'config/environment'

import { isAbsoluteURL } from 'modules/core/lib/isAbsoluteURL'

let globalEnvironment: Environment | null = null

export const init = (environment: Environment) => {
  globalEnvironment = environment
}

export const buildUrl = (path: string | undefined | null) => {
  if (!globalEnvironment) throw new Error('You must set an environment first!')

  if (!path) return ''

  if (isAbsoluteURL(path)) return path

  return `${globalEnvironment.apiEndpoint}${path}`
}

export const buildRealtimeUrl = (path: string | undefined | null) => {
  if (!globalEnvironment) throw new Error('You must set an environment first!')

  if (!path) return ''

  if (isAbsoluteURL(path)) return path

  return `${globalEnvironment.apiRealtimeEndpoint}${path}`
}

export const buildFactorialIdUrl = (path: string | undefined | null) => {
  if (!globalEnvironment) throw new Error('You must set an environment first!')

  if (!path) return ''

  if (isAbsoluteURL(path)) return path

  return `${globalEnvironment.factorialIdEndpoint}${path}`
}

export const buildWebpageUrl = (path?: string) => {
  if (!globalEnvironment) throw new Error('You must set an environment first!')

  if (!path) return ''

  if (isAbsoluteURL(path)) return path

  return `${globalEnvironment.webpageLocation}${path}`
}

export default buildUrl
